import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import Footer from "@/components/Footer";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background">
      <main className="text-center flex-1 flex items-center justify-center">
        <div className="animate-fade-in space-y-6">
          <h1 className="text-8xl font-bold text-primary animate-bounce-in">404</h1>
          <p className="text-2xl text-muted-foreground">Oops! Page not found</p>
          <a 
            href="/" 
            className="inline-block text-primary underline hover:text-primary/80 animated-underline transition-colors"
          >
            Return to Home
          </a>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;
